var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.getAPIUrl()}},[_c('img',{staticStyle:{"width":"100%"},style:(_vm.buttonHeight()),attrs:{"src":require("../../../assets/appleWalletbutton.png"),"alt":"appleButton"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }